<template>
  <div>
    <QuoteInfo v-if="isShowQuoteInfo" :actionButtons="actionButtons" :actionButtonClicked="actionButtonClicked"
      :isQrEnabled="isQrEnabled" />

    <div id="exampleModal" ref="modal" class="modal fade modal-lg" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <QuoteModal :quote-summary="summary" @event="CancelCallback" :read-only="true" />
      </div>
    </div>

    <div id="exampleModal" ref="cancelQuote" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <CancelQuoteDialog @event="CancelCallback" />
      </div>
    </div>

    <div id="exampleModal" ref="cancelQuoteI" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <CancelQuoteDialogI @event="CancelCallback" />
      </div>
    </div>

    <!-- 
<div v-if="isQRCodeOpen" id="notesModal" class="modal fade modal-md show bg-opacity-50 bg-[#000]" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content !rounded-[20px] !w-[300px] mx-auto">
          <div class="modal-body p-4">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                  <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                  <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">QR Code</h2>
                </div>
                <button class="w-[40px] h-[40px] p-2 rounded-full bg-opacity-60 bg-[#EFEFEF]" @click="closeModal"
                  type="button" data-bs-dismiss="modal" aria-label="Close">
                  <img src="@/assets/images/modal-cross-icon.png">
                </button>
              </div>
              <div class="w-[250px] h-[250px] mx-auto border border-[#EFEFEF]">
                <img src="../../assets/images/modal-QR-code.png" alt="" class="w-full h-full">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <div id="exampleModal" ref="qrDialog" class="modal fade modal-lg" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <QRDialog v-if="qrCodeCounter > 0" @event="QRCallback" />
      </div>
    </div>

    <div id="shareQuote" ref="shareQuote" class="modal fade" data-bs-backdrop="static" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shareModal">
          <div class="flex items-center justify-between px-3.5 py-2.5">
            <div class="flex items-center gap-2">
              <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
              <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
              <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Send Quote</h2>
            </div>
            <button @click="closeModal" type="button" data-bs-dismiss="modal" aria-label="Close"
              class="w-[40px] h-[40px] p-2 bg-[#fff]">
              <img src="@/assets/images/modal-cross-icon.png" class="w-full h-full">
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center">
              Please enter the email address or phone number below to send quote
            </p>
            <div class="mb-3">
              <label for="recipient-name" class="col-form-label">Email Address:</label>
              <input id="recipient-name" v-model="email" placeholder="Enter Email address" type="text"
                class="form-control">
            </div>
            <div class="mb-3">
              <label for="message-text" class="col-form-label">Phone Number:</label>
              <input id="recipient-name" v-model="phone" placeholder="Enter Phone Number" type="text"
                class="form-control" @input="acceptNumber">
            </div>
          </div>
          <div class="modal-footer">
            <div class="flex justify-center gap-2.5">
              <button @click="closeModal"
                class="px-2.5 py-7 rounded-lg text-[16px] font-lato transition duration-300 bg-[#FE5000] hover:bg-[#003087] text-[#fff]">
                Cancel
              </button>
              <button @click="onSubmit()"
                class="px-2.5 py-7 rounded-lg text-[16px] font-lato transition duration-300 bg-[#FE5000] hover:bg-[#003087] text-[#fff]">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isNotesOpen" id="notesModal" class="modal fade modal-md show bg-opacity-50 bg-[#000]" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content !rounded-[20px]">
          <div class="modal-body p-4 pb-5">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                  <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                  <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Internal Notes</h2>
                </div>
                <button class="w-[40px] h-[40px] p-2 rounded-full bg-opacity-60 bg-[#EFEFEF]" @click="closeNotesModal"
                  type="button" data-bs-dismiss="modal" aria-label="Close">
                  <img src="@/assets/images/modal-cross-icon.png">
                </button>
              </div>
              <noteBox />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QuoteModal from "@/components/quote_modal/QuoteModal.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import { Modal } from "bootstrap";
import QuoteInfo from "@/components/quote/QuoteInfo.vue";
import CancelQuoteDialog from "@/components/tradecall_dialog/CancelQuoteDialog.vue";
import CancelQuoteDialogI from "@/components/tradecall_dialog/CancelQuoteDialog_.vue";
import QRDialog from "@/components/qr_replacement/QRDialog.vue";
import noteBox from "../../components/notes/noteBox.vue";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";


export default {
  components: {
    QuoteInfo,
    QuoteModal,
    CancelQuoteDialog,
    CancelQuoteDialogI,
    QRDialog,
    noteBox
  },

  data() {
    return {
      summary: null,
      actionButtons: [],
      isShowQuoteInfo: false,
      timer: null,
      phone: "",
      email: "",
      qrCodeCounter: 1,
      isQrEnabled: false,
      isNotesOpen: false,
    };
  },
  computed: {
    ...mapGetters([
      "qrResponse",
      "quoteEmailResponse",
      "quoteDetail",
      "quoteSummary",
      "checkoutResponse",
      "cancelReasons",
      "waiveTradeCallFee",
      "resubmitQuote",
      "createInvoiceResponse"
    ]),
  },

  watch: {

    resubmitQuote: function (data) {

      if (data) {
        this.getQuoteDetail({
          manual_quote_id: this.$route.params.id,
        });
      }
    },

    waiveTradeCallFee: function (data) {

      if (data) {

        if (this.quoteDetail.is_quote_submitted) {
          // resubmit quote
          this.resubmitManualQuote({
            manual_quote_id: this.$route.params.id,
          });

        }
        else {
          this.getQuoteDetail({
            manual_quote_id: this.$route.params.id,
          });
        }

      }
    },
    qrResponse: function (data) {
      this.qrCodeCounter = this.qrCodeCounter + 1
      this.modal = new Modal(this.$refs.qrDialog);
      this.modal.show();
      disableScroll()
    },

    quoteEmailResponse: function (data) {
      toast.success(data.message);
      this.modal.hide();
      enableScroll()
    },
    quoteDetail: function (data) {

      this.isShowQuoteInfo = true;
      this.actionButtons = [];
      this.isQrEnabled = false
      if (data.items.length > 0) {
        this.actionButtons.push({title:'View Quote', image:'view-quote.png'});
      }
      if (data.status.technician.status == 0) {
        if (data.is_quote_submitted == 1) {
          this.actionButtons.push({title:'Checkout', image:'checkout.png'});
        }
        this.actionButtons.push({title:'Edit Quote', image:'edit-quote.png'});
        if (data.partner_info.is_allied == "1") {
          this.getReasonsCall();
        }
      } else if (data.status.technician.status == 2) {
        this.actionButtons.push({title:'Start Job', image:'start-quote.png'});
        this.actionButtons.push({title:'Pause Job', image:'pause-job.png'});
      } else if (data.status.technician.status == 6) {
        this.actionButtons.push({title:'Resume Job', image:'resume-job.png'});
      } else if (data.status.technician.status == 7) {
        this.actionButtons.push({title:'Complete Job', image:'complete-job.png'});
        this.actionButtons.push({title:'Pause Job', image:'pause-job.png'});
      } else if (data.status.technician.status == 3) {
        this.checkoutAcknowledge({
          manual_quote_id: this.$route.params.id,
          decision: "yes",
        });
      } else if (data.status.technician.status == 4) {
        this.startQuote({
          manual_quote_id: this.$route.params.id,
        });
      }
      this.actionButtons.push({title:'Internal Notes', image:'internal-notes.png'});

      if (data.is_quote_submitted == 1) {
        this.actionButtons.push({title:'Share Quote', image:'share-quote.png'});
        this.isQrEnabled = true

      }

      if (data.status.technician.status == 0 && data.is_quote_submitted == 1) {
        this.actionButtons.push({title:'Cancel Quote', image:'cancel-quote.png'});
      }

      if (data.waive_trade_call_fee_button == 1) {
        this.actionButtons.push({title:'Waive TradeCall Fee', image:'waive-tradecall-fee.png'});

      }

    },

    quoteSummary: function (data) {
      this.summary = data;
      this.modal = new Modal(this.$refs.modal);
      this.modal.show();
      disableScroll()
    },

    checkoutResponse: function () {
      this.getQuoteDetail({
        manual_quote_id: this.$route.params.id,
      });
    },

    createInvoiceResponse: function () {
      this.$router.push({
        path: `/checkout/invoice/${this.createInvoiceResponse.invoice_id}`
      });
    },


  },

  mounted() {

    this.timer = setInterval(() => {
      this.getQuoteDetail({
        manual_quote_id: this.$route.params.id,
        is_hide: true,
      });
    }, 45000);

    this.getQuoteDetail({
      manual_quote_id: this.$route.params.id,
    });
    if (this.$route.query.is_edit == 1) {
      localStorage.setItem(this.$route.params.id + "-quote", null);
      this.$router.push({
        path: `/quote/edit/${this.$route.params.id}`,
        query: {
          is_edit: 1,
        },
      });
    }
  },

  beforeRouteLeave() {
    clearInterval(this.timer);
  },

  methods: {
    ...mapActions([
      "sendQuoteToEmail",
      "setCommponent",
      "getQuoteDetail",
      "postCancelQuote",
      "postDeclineQuote",
      "getQuoteSummary",
      "startQuote",
      "pauseQuote",
      "completeQuote",
      "checkoutAcknowledge",
      "getReasons",
      "getQRCode",
      "waiveTradeCall",
      "resubmitManualQuote",
      "createInvoice",
    ]),


    checkNoteAlert() {
      if (this.quoteDetail &&
        this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.show_replacement_opportunity_badge == '1'
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.company_name != 'Vivint'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
        return true
      } else {
        return false
      }
    },

    onSubmit() {
      if (this.isValid()) {
        this.sendQuoteToEmail({
          manual_quote_id: this.$route.params.id,
          email: this.email.trim(),
          phone: this.phone,
        });
      }
    },

    getReasonsCall() {
      this.getReasons({
        id: this.$route.params.id
      });
    },

    isValid() {
      var status = true;

      if (this.email.length <= 0 && this.phone.length <= 0) {
        toast.error(
          "Please enter the email address or phone number below to send quote."
        );
        status = false;
      } else {
        if (!this.validateEmail() && this.email.length > 0) {
          toast.error("Email address not valid.");
          status = false;
        }

        if (this.phone.length < 14 && this.phone.length > 0) {
          toast.error("Phone number not valid.");
          status = false;
        }
      }

      return status;
    },

    validateEmail() {
      var regex = this.$constants.EMAIL_REGEX;
      return regex.test(this.email);
    },
    acceptNumber() {
      var x = this.phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },

    CancelCallback(opt, data) {
      if (opt == "close") {
        enableScroll()
        this.modal.hide();
      } else if (opt == "confirm") {
        data.manual_quote_id = this.$route.params.id;
        enableScroll()
        this.modal.hide();
        if (this.quoteDetail.partner_info.negative_action == 'decline') {
          this.postDeclineQuote(data);
        } else {
          this.postCancelQuote(data);
        }
      }
    },

    QRCallback(opt) {
      if (opt == "close") {
        this.modal.hide();
      } else if (opt == "confirm") {
        this.modal.hide();
      }
    },

    qrCodeAppiCall() {
      this.getQRCode({
        job_id: this.quoteDetail.id,
        job_source: "iq",
      });
    },

    waiveTradeCallFeeClicked() {
      this.$dialog.show({
        title: "Alert",
        text: "Are you sure you want to waive your TradeCall fee?",

        onConfirm: () => {

          this.waiveTradeCall({
            manual_quote_id: this.$route.params.id,
          });
        },
      });
    },
    actionButtonClicked(action) {
      if (action == "Edit Quote") {
        localStorage.setItem(this.$route.params.id + "-quote", null);
        this.$router.push({
          path: `/quote/edit/${this.$route.params.id}`,
        });
      } else if (action == "View Quote") {
        var params = {
          manual_quote_id: this.quoteDetail.id,
        };
        params["status"] = "submitted";

        if (this.isPartnerQuote) {
          this.getQuoteSummary({
            url: "/manual-quote/partner/summary",
            params: params
          });
        } else {
          this.getQuoteSummary({
            url: "/manual-quote/summary/calculate",
            params: params
          });
        }
      } else if (action == "Cancel Quote") {
        if (this.quoteDetail.partner_info.is_allied == "1") {
          this.modal = new Modal(this.$refs.cancelQuoteI);
          this.modal.show();
          disableScroll()
        } else {
          this.modal = new Modal(this.$refs.cancelQuote);
          this.modal.show();
          disableScroll()
        }
      } else if (action == "Start Job") {
        this.startQuote({
          manual_quote_id: this.$route.params.id,
        });
      } else if (action == "Resume Job") {
        this.startQuote({
          manual_quote_id: this.$route.params.id,
        });
      } else if (action == "Pause Job") {
        this.pauseQuote({
          manual_quote_id: this.$route.params.id,
        });
      } else if (action == "Complete Job") {
        this.completeQuote({
          manual_quote_id: this.$route.params.id,
        });
      } else if (action == "Share Quote") {

        this.email = this.quoteDetail.consumer.email ?? ""
        this.phone = this.quoteDetail.consumer.phone ?? ""

        this.modal = new Modal(this.$refs.shareQuote);
        this.modal.show();
        disableScroll()
      } else if (action == "QR Code") {
        this.qrCodeAppiCall();
      }
      else if (action == "Waive TradeCall Fee") {
        this.waiveTradeCallFeeClicked()
      } else if (action == "Checkout") {
        this.createInvoice({
          job_id: this.$route.params.id,
          job_type: 'mq'
        });
      } else if (action == "Internal Notes") {
        this.openNotesModal()
      }

    },

    openNotesModal() {
      disableScroll()
      this.isNotesOpen = true;
    },
    closeNotesModal() {
      enableScroll()
      this.isNotesOpen = false;
    },

    closeModal() {
      enableScroll()
      this.modal.hide();
    },
  },
};
</script>

<style>
.primaryBtn {
  background: #fe5000 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 5px #999 !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
}

.secondaryBtn {
  background: #003087 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 5px #999 !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
}

.shareModal .modal-header {
  background: #003087;
  text-align: center;
  color: #fff;
  justify-content: space-between;
  display: block;
}

.shareModal .modal-footer {
  justify-content: center;
}

.shareModal .modal-footer button {
  border-radius: 8px;
  padding: 10px 30px;
  background: #fe5000;
  border: none;
}

.shareModal .modal-footer button:hover {
  background: #003087;
}

.shareModal .modal-footer button.btn-secondary {
  background: #003087;
}

.btn-close-Pop {
  background: none;
  border: 0;
  position: absolute;
  top: 15px;
  right: 10px;
}

.shareModal label {
  color: #fe5000;
}

.actionQouteBtn {
  text-align: center;
}

.actionQouteBtn h3 {
  color: #003087;
  margin-bottom: 25px;
  border-bottom: 2px solid #00308726;
  padding-bottom: 15px;
  text-align: left;
}

@media screen and (max-width: 992px) {
  .actionQouteBtn .btn-group button {
    margin-bottom: 0.5rem;
    font-size: 16px;
    padding: 0.5rem 1.2rem;
  }
}

@media screen and (max-width: 575px) {
  .actionQouteBtn .btn-group button {
    margin-bottom: 0.5rem;
    font-size: 15px;
    padding: 0.5rem 1rem;
  }
}
</style>
